export function phoneFromContact(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.startsWith("380") && digits.length >= 12) {
    return formatOnePhone(`0${digits.slice(3, 12)}`);
  }
  if (digits.startsWith("80") && digits.length >= 11) {
    return formatOnePhone(`0${digits.slice(2, 11)}`);
  }
  if (digits.length === 9) {
    return formatOnePhone(`0${digits}`);
  }
  if (digits.length >= 10) {
    return formatOnePhone(digits.startsWith("0") ? digits.slice(0, 10) : digits);
  }
  return value.trim();
}

function formatOnePhone(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 10 && digits.startsWith("0")) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8)}`;
  }
  return value.trim();
}

export function splitPhones(value: string): string[] {
  return value
    .split(/[,;]+/)
    .map((part) => phoneFromContact(part.trim()))
    .filter(Boolean);
}

export function joinPhones(phones: string[]): string {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const value of phones) {
    for (const formatted of splitPhones(value)) {
      const key = formatted.replace(/\D/g, "");
      if (!formatted || !key || seen.has(key)) continue;
      seen.add(key);
      result.push(formatted);
    }
  }
  return result.join(", ");
}

export function normalizePhone(value: string): string {
  return joinPhones(splitPhones(value));
}

export function addPhone(existing: string, next: string): string {
  return joinPhones([existing, next]);
}

export function formatPhoneUk(value: string): string {
  return normalizePhone(value) || value.trim();
}

export function phoneTelHref(value: string): string {
  const digits = value.replace(/\D/g, "");
  return digits ? `tel:${digits}` : "";
}
